import React, { useRef } from 'react';
import { Button } from '@welbe/design-system';
import { useReactToPrint } from 'react-to-print';

import {
	Container,
	Title,
	Subtitle,
	ContainerCard,
	ContainerButton,
} from './Campaigns.styles';
import { Card } from './components/Card/Card';

type campaign = {
	id: string;
	title: string;
	companyName: string;
	date: string;
	iconType: string;
	disabled: boolean;
};

interface CompaignsContentProps {
	onCreateNewCampaign: () => void;
	onEditCampaign: (id: string) => void;
	campaigns: campaign[];
}

export const CompaignsContent = ({
	onCreateNewCampaign,
	onEditCampaign,
	campaigns,
}: CompaignsContentProps): JSX.Element => {
	const componentRef = useRef(null);
	const handlePrint = useReactToPrint({
		content: () => componentRef?.current || null,
	});

	return (
		<div>
			<Container ref={componentRef}>
				<Title onClick={handlePrint}>
					NORMA OFICIAL MEXICANA NOM-035-STPS-2018
				</Title>
				<Subtitle>
					Factores de riesgo psicosocial en el trabajo-identificación, análisis
					y prevención.
				</Subtitle>
				<ContainerCard>
					{campaigns.map((campaign: any) => (
						<Card
							key={campaign.id}
							disabled={campaign.disabled}
							onClick={() => onEditCampaign(campaign.id)}
							title={campaign.title}
							companyName={campaign.companyName}
							date={campaign.date}
							iconType={campaign.iconType}
						/>
					))}
				</ContainerCard>
			</Container>
			<ContainerButton>
				<Button onClick={onCreateNewCampaign}>Crear nueva campaña</Button>
			</ContainerButton>
		</div>
	);
};
